module.exports = __webpack_public_path__ + "static/media/piano.caecbcff.jpg";